import { useFormikContext } from "formik";
import React from "react";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Button from "react-bootstrap/esm/Button";

export const ApplicationSubmission = ({props}) => {
    const { isSubmitting, status } = useFormikContext(); // use to disable button while the request is being made to server and to check for successful api call

    const {employmentStatus, selectedJob} = props
    const inHouse = selectedJob.inHouse
    let statusMessage = "";

    if (status?.error === true) {
        statusMessage = (
            <p role="alert" className="text-danger">Error submitting application.</p>
        );
    } else if (status?.error === false) {
        
        statusMessage = (
            <p role="alert" className="text-success">Application successfully submitted!</p>
        );
    } else {
        statusMessage = "";
    }

    return (
        <>
            <Row>{statusMessage}</Row>
            <Row>
                <Col>
                    <Button
                        className="btn btn-success btn-lg"
                        type="submit"
                        disabled={isSubmitting || (!employmentStatus && inHouse === "Yes")}
                        aria-label="submit application Button"
                        aria-invalid={status?.error === true ? "true" : null}
                        // onClick={() => handleClick()}
                    >
                        Submit
                    </Button>
                    { inHouse === "Yes" && !employmentStatus && (<p className="text-danger">To apply for this In-house position: you must be currently employed with the Navajo Nation and fill out your AB Number, Employment Status and Position Title in Profile.</p>)}
                </Col>
            </Row>
        </>
    );
};
